import type MP4Box from 'mp4box';
import { TrackEventProp } from '@studio/constants/tracking-constants';
import type { AddError, VideoUploadTrackEventProperties } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';
import { hasAudio } from '../hasAudio';

// allows max bit rate and some extra.
// Technically max bit rate is 192kbps, but we allow 9% higher
export const EXTRA_ALLOWED_FACTOR = 1.09;

const validateAudioBitrate = (
  info: MP4Box.Mp4BoxInfo,
  addError: AddError,
  trackEventProperties: VideoUploadTrackEventProperties
): number => {
  if (!hasAudio(info)) {
    return 0;
  }
  const [audioTrack] = info.audioTracks;
  const bitrate = audioTrack.bitrate / 1000;

  trackEventProperties[TrackEventProp.VIDEO_UPLOAD_AUDIO_BITRATE_KBPS] = bitrate;

  const maxBitrate = audioTrack.audio.channel_count * (192 * EXTRA_ALLOWED_FACTOR);
  console.log(`Audio bitrate: ${bitrate.toFixed(3)} kbps: Max allowed ${maxBitrate}`);

  if (bitrate > maxBitrate) {
    addError(VALIDATIONS.MAX_AUDIO_BITRATE);
  }
  return bitrate;
};

export default validateAudioBitrate;
